import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, HelpCircle, AlertTriangle } from 'lucide-react';
export function PainSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-41">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-42">
        {/* The Struggle */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-16" data-id="element-43">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-8" data-id="element-44">
            ¿Te pasa esto?
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-lg text-[#666666] mb-8" data-id="element-45">
            <span className="font-medium" data-id="element-46">Intentás hacer esquejes</span>
            <span className="hidden md:block text-[#4a7c2c]" data-id="element-47">→</span>
            <span className="md:hidden" data-id="element-48">↓</span>
            <span className="font-medium" data-id="element-49">seguís consejos</span>
            <span className="hidden md:block text-[#4a7c2c]" data-id="element-50">→</span>
            <span className="md:hidden" data-id="element-51">↓</span>
            <span className="font-medium" data-id="element-52">probás distintos métodos</span>
          </div>

          <p className="text-2xl font-bold text-[#d32f2f] mb-12" data-id="element-53">
            …y aun así no prosperan.
          </p>

          <div className="bg-[#fafaf9] p-8 rounded-2xl border border-gray-100 shadow-sm" data-id="element-54">
            <h3 className="text-xl font-bold text-[#1a1a1a] mb-6 flex items-center justify-center gap-2" data-id="element-55">
              <HelpCircle className="w-6 h-6 text-[#4a7c2c]" data-id="element-56" />
              No sabés:
            </h3>
            <ul className="space-y-4 text-left max-w-md mx-auto" data-id="element-57">
              <li className="flex items-start gap-3" data-id="element-58">
                <XCircle className="w-5 h-5 text-[#d32f2f] mt-1 shrink-0" data-id="element-59" />
                <span className="text-[#666666]" data-id="element-60">si cortar o esperar</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-61">
                <XCircle className="w-5 h-5 text-[#d32f2f] mt-1 shrink-0" data-id="element-62" />
                <span className="text-[#666666]" data-id="element-63">si regar o no</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-64">
                <XCircle className="w-5 h-5 text-[#d32f2f] mt-1 shrink-0" data-id="element-65" />
                <span className="text-[#666666]" data-id="element-66">
                  si el problema es el sustrato, el clima o vos
                </span>
              </li>
            </ul>
            <p className="mt-8 text-lg font-medium text-[#1a1a1a]" data-id="element-67">
              Mientras dudás, las plantas no avanzan.
            </p>
          </div>
        </motion.div>

        {/* The Real Problem */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="bg-[#2d5016] text-white p-8 md:p-12 rounded-3xl text-center" data-id="element-68">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-69">
            El problema no sos vos
          </h2>
          <p className="text-xl text-[#a5d6a7] mb-8" data-id="element-70">
            El problema es cómo se explica el proceso.
          </p>

          <div className="grid md:grid-cols-2 gap-6 text-left max-w-2xl mx-auto mb-8" data-id="element-71">
            <div className="flex items-start gap-3" data-id="element-72">
              <AlertTriangle className="w-5 h-5 text-[#ffb74d] mt-1 shrink-0" data-id="element-73" />
              <span data-id="element-74">La mayoría de la información está desordenada</span>
            </div>
            <div className="flex items-start gap-3" data-id="element-75">
              <AlertTriangle className="w-5 h-5 text-[#ffb74d] mt-1 shrink-0" data-id="element-76" />
              <span data-id="element-77">No explica el cuándo ni el por qué</span>
            </div>
            <div className="flex items-start gap-3" data-id="element-78">
              <AlertTriangle className="w-5 h-5 text-[#ffb74d] mt-1 shrink-0" data-id="element-79" />
              <span data-id="element-80">No está pensada para nuestro clima</span>
            </div>
            <div className="flex items-start gap-3" data-id="element-81">
              <AlertTriangle className="w-5 h-5 text-[#ffb74d] mt-1 shrink-0" data-id="element-82" />
              <span data-id="element-83">Te obliga a improvisar</span>
            </div>
          </div>

          <p className="text-2xl font-bold" data-id="element-84">Y ahí aparecen los errores.</p>
        </motion.div>
      </div>
    </section>;
}